import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';
import UserContext from '../../contexts/UserContext';
import authenticate from '../../utils/Authenticate';
import displayError from '../../utils/ErrorHandler';

const Requests = () => {
  const { user, setUser } = useContext(UserContext);
  const location = useLocation();
  const [requests, setRequests] = useState([]);
  const [backendCall, setBackendCall] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [focusedItem, setFocusedItem] = useState(null);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const itemRefs = useRef([]);
  const [newlyApprovedIndexes, setNewlyApprovedIndexes] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [bills, setBills] = useState({});
  const [submittedRequests, setSubmittedRequests] = useState([]);
  const submitRefs = useRef({});
  useEffect( () => {
    async function startup(){
      if(!user){
        await authenticate(setUser,navigate);
      }
    }
    startup();
  },[user])

  

  useEffect(() => {
    const initialize = async () => {
      if (!user) {
        await authenticate(setUser, navigate);
      }

      if (user) {
        if (backendCall) {
          setRequests(responseData);
        } else {
          setRequests(location.state || []);
        }
      }
    };

    initialize();
  }, [user, backendCall, responseData, location.state, navigate, setUser]);

const fetchedBillKeys = useRef(new Set());

useEffect(() => {
  requests?.itemRequest?.forEach((request) => {
    request.items.forEach((item) => {
      const supplierName = item?.item?.supplier?.name || item?.supplier?.id?.name || item?.zoneSupplier?.id?.name;
      const key = `${request._id}_${supplierName}`;

      if (supplierName && request._id && !fetchedBillKeys.current.has(key)) {
        fetchedBillKeys.current.add(key);
        getBillsForRequests(request._id, supplierName);
      }
    });
  });
}, [requests]);

useEffect(() => {
  requests?.itemRequest?.forEach((request, index) => {
    if (
      (request.supplierSelected || newlyApprovedIndexes.includes(index)) &&
      submitRefs.current[request._id]
    ) {
      submitRefs.current[request._id].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  });
}, [requests, newlyApprovedIndexes]);


const getBillsForRequests = async (requestId, supplierName) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URI}/api/bill/get?requestId=${requestId}&supplierName=${supplierName}`,
      { withCredentials: true }
    );

    const key = `${requestId}_${supplierName}`;

    if (response.data.success) {
      setBills(prev => ({
        ...prev,
        [key]: response.data.data
      }));
    } else {
      setBills(prev => ({
        ...prev,
        [key]: null
      }));
    }
  } catch (err) {
    setErrorMessage('An error occurred while fetching bills.');
    console.error(err);
  }
};

  useEffect(() => {
    if (location.state?.focusedItem) {
      setFocusedItem(location.state.focusedItem);
    }
  }, [location.state]);

  useEffect(() => {
    if (focusedItem !== null && itemRefs.current[focusedItem]) {
      itemRefs.current[focusedItem]?.scrollIntoView({ behavior: 'smooth' });
      itemRefs.current[focusedItem]?.focus();
    }
  }, [focusedItem]);
const [loadingRequests, setLoadingRequests] = useState([]);
  const submitSupplierForRequest = async (e, currrequest, curitems) => {
  e.preventDefault();
  const requestId = currrequest._id;

  setLoadingRequests(prev => [...prev, requestId]);

  const filteredItems = curitems.filter(item =>
    item?.supplier?.id !== undefined && item?.supplier?.id !== null
  );

  const clonedRequest = {
  ...currrequest,
  items: filteredItems,
  menu: currrequest.menu, // Preserve menu
};

  const finalObject = {
    request: clonedRequest,
    items: filteredItems
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URI}/api/request/requestSupply`,
      finalObject,
      { withCredentials: true }
    );

    const updatedData = response.data.data;

    setSubmittedRequests(prev => [...new Set([...prev, requestId])]);
    setResponseData(updatedData);
    setRequests(updatedData);
    setNewlyApprovedIndexes([]);
    setBackendCall(true);
  } catch (err) {
    const errorMessage = displayError(err, navigate, setUser);
    if (errorMessage) setMessage(errorMessage);
  } finally {
    setLoadingRequests(prev => prev.filter(id => id !== requestId));
  }
};

  const removeSupplier = (itemToRemove, requests) => {
    const updatedRequests = requests?.itemRequest?.map((request) => {
      const updatedItems = request.items.map((item) => {
        if (item.item._id === itemToRemove.item._id) {
          item.supplier = null;
          item.zoneSupplier = null;
        }
        return item;
      });

      const anyItemHasZoneSupplierSelected = updatedItems.some(item => (item?.zoneSupplier !== undefined && item?.zoneSupplier !== null));
      const anyItemHasSupplierAssigned = updatedItems.some(item => (item?.supplier !== undefined && item?.supplier !== null));
      request.items = updatedItems;
      request.supplierSelected = anyItemHasSupplierAssigned && anyItemHasZoneSupplierSelected;

      return request;
    });

    setRequests({
      ...requests,
      itemRequest: updatedRequests,
    });
  };

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'pending':
        return 'bg-orange-100 text-orange-800';
      case 'approved':
        return 'bg-green-100 text-green-800';
      case 'rejected':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-blue-100 text-blue-800';
    }
  };

  const handleCheckboxChange = (e, requestIndex) => {
  const isChecked = e.target.checked;

  if (isChecked) {
    setNewlyApprovedIndexes(prev => [...new Set([...prev, requestIndex])]);
  } else {
    setNewlyApprovedIndexes(prev => prev.filter(index => index !== requestIndex));
  }
};


  return (
    <>
      <div>
        {message ? (
          <div
            className="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative"
            role="alert"
          >
            <span className="block sm:inline">{message}</span>
            <span className="absolute top-0 bottom-0 right-0 px-4 py-3"></span>
          </div>
        ) : null}
        <div className="bg-lime-800 p-4 shadow-md w-full fixed z-10">
          <div className="flex items-center justify-between w-full relative">
            {/* Back Button */}
            <div
              className="flex-shrink-0 cursor-pointer text-white text-xl"
              onClick={() => navigate(-1)}
            >
              ←
            </div>

            {/* Centered Heading */}
            <div className="absolute left-1/2 transform -translate-x-1/2 text-center">
              <h4 className="text-sm sm:text-lg font-semibold text-lime-100 whitespace-nowrap">
                Zone {requests.id} - {requests.desc}
              </h4>
              <h4 className="text-sm text-lime-200 font-semibold whitespace-nowrap">
                Coordinator:{" "}
                {requests?.coordinator?.length > 0
                  ? requests.coordinator[0].name?.charAt(0).toUpperCase() +
                    requests.coordinator[0].name?.slice(1)
                  : null}
              </h4>
            </div>

            {/* Right-side buttons */}
            <div className="flex gap-2 ml-auto">
              <button
                className="bg-fmb text-white px-4 py-2 rounded text-xs sm:text-base"
                onClick={() => {
                  setUser({ ...user, zone: requests });
                  navigate("/zc/stock");
                }}
              >
                View Stock
              </button>

              <button
                className="bg-fmb text-white px-4 py-2 rounded text-xs sm:text-base"
                onClick={() => {
                  setUser({ ...user, zone: requests });
                  navigate("/zc/view-miqaats");
                }}
              >
                View Zone Miqaat
              </button>
            </div>
          </div>
        </div>

        <div className="wrapper pt-[85px]">
          {requests?.itemRequest?.map((request, requestIndex) => (
            <div
              key={requestIndex}
              className="mx-4 my-2 rounded-xl bg-white shadow-lg border border-gray-200 overflow-hidden"
            >
              <div className="flex justify-between items-center">
                <div
                  className={`absolute top-0 left-0 text-sm p-2 px-4 rounded-r-lg leading-tight font-semibold ${getStatusClass(
                    request.status
                  )}`}
                >
                  {request.status
                    ? request.status?.charAt(0)?.toUpperCase() +
                      request.status?.slice(1)
                    : null}
                </div>
              </div>

              <div className="p-5 relative">
                <div className="flex justify-between items-center mt-7">
                  <div className="mb-2">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate("/zc/home/show-bills", {
                          state: {
                            viewRquestId: `REQ #00${request.requestNumber}`,
                            requestId: request._id,
                            zoneId: request.zone?._id || request.zone,
                          },
                        });
                      }}
                      className="text-sm text-blue-600 underline"
                    >
                      Show Bill
                    </button>
                  </div>
                  {request.menu ? (
                    <div className="uppercase tracking-wide text-sm text-gray-600 font-semibold">
                      {request.menu.name}
                    </div>
                  ) : (
                    <div className="uppercase tracking-wide text-sm text-gray-600 font-semibold">
                      REQ00{request.requestNumber}
                    </div>
                  )}
                  <div className="text-gray-500 text-sm">
                    {new Date(request.createdAt).toDateString()}
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div>
                    <input
                      type="checkbox"
                      checked={request.check}
                      disabled={request.check}
                      onChange={(e) => handleCheckboxChange(e, requestIndex)}
                      className={`w-4 h-4 rounded ${
                        submittedRequests.includes(request._id) 
                          ? "accent-green-500"
                          : "accent-blue-500"
                      }`}
                    />
                    {submittedRequests.includes(request._id) || request.check ? (
                      <span className="text-sm text-green-500 font-bold">
                        Request Approved
                      </span>
                    ) : (
                      <span className="text-sm">Approve Request</span>
                    )}
                  </div>
                </div>
                <div className="mt-4">
                  {request.items.map((item, itemIndex) => (
                    <React.Fragment key={itemIndex}>
                      <div
                        ref={(el) =>
                          (itemRefs.current[`${requestIndex}-${itemIndex}`] =
                            el)
                        }
                        tabIndex="-1"
                        className="grid grid-cols-2 gap-4 items-center"
                      >
                        <div>
                          <h2 className="text-[15px] font-semibold text-fmb">
                            {item.item.name}
                          </h2>
                          <p className="text-xs text-gray-600">
                            {item.item.category}
                          </p>
                          <p className="text-sm font-semibold text-gray-600">
                            {typeof item.quantityReceived === "number" ? (
                              <span className="text-sm text-green-600">
                                {item.quantityReceived}
                              </span>
                            ) : (
                              <span className="text-sm text-gray-400">
                                {item.quantity}
                              </span>
                            )}{" "}
                            {item.item.unit}
                          </p>
                        </div>
                        <div className="flex items-center gap-1 justify-end">
                          {/* <div>
                            {bills[request._id] ? (
                            <div className="text-xs text-blue-500">
                                Bill Found: {bills[request._id].length}
                              </div>
                            ) : (
                              <div className="text-xs text-gray-400">No bill available</div>
                            )}
                          </div> */}
                          {item.item?.supplier?._id ||
                          item.supplier?.id?._id ||
                          item.zoneSupplier?.id ||
                          item.item?.purchaseType === "zone" ? (
                            item.zoneSupplier?.id ||
                            item.item?.purchaseType === "zone" ? (
                              <>
                                <div>
                                  {(() => {
                                    const supplierName =
                                      item?.item?.supplier?.name ||
                                      item?.supplier?.id?.name ||
                                      item?.zoneSupplier?.id?.name;

                                    const billKey = `${request._id}_${supplierName}`;
                                    const billData = bills[billKey];

                                    if (billData) {
                                      return (
                                        <div className="">
                                          <a
                                            href={billData.file}
                                            target="_blank"
                                          >
                                            <button className="bg-fmb text-white py-2 px-3 rounded text-sm font-normal hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50">
                                              View Bill
                                            </button>
                                          </a>
                                        </div>
                                      );
                                    } else {
                                      return (
                                        <div className="text-xs text-gray-400">
                                          {/* No bill available */}
                                        </div>
                                      );
                                    }
                                  })()}
                                </div>
                                <div className="flex flex-row items-end text-right">
                                  <span className="text-sm text-gray-500 font-semibold">
                                    {" "}
                                    {item?.item?.supplier?.name ||
                                      item.supplier?.id?.name ||
                                      item.zoneSupplier?.id?.name}
                                  </span>
                                </div>
                              </>
                            ) : (
                              <>
                                <div>
                                  {(() => {
                                    const supplierName =
                                      item?.item?.supplier?.name ||
                                      item?.supplier?.id?.name ||
                                      item?.zoneSupplier?.id?.name;

                                    const billKey = `${request._id}_${supplierName}`;
                                    const billData = bills[billKey];

                                    if (billData) {
                                      return (
                                        <div className="">
                                          <a
                                            href={billData.file}
                                            target="_blank"
                                          >
                                            <button className="bg-fmb text-white py-2 px-3 rounded text-sm font-normal hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50">
                                              View Bill
                                            </button>
                                          </a>
                                        </div>
                                      );
                                    } else {
                                      return (
                                        <div className="text-xs text-gray-400">
                                          {/* No bill available */}
                                        </div>
                                      );
                                    }
                                  })()}
                                </div>
                                <div className="flex flex-row items-center">
                                  <span className="px-4 text-sm text-gray-500 font-semibold">
                                    {" "}
                                    {item?.item?.supplier?.name ||
                                      item.supplier?.id?.name ||
                                      item?.supplier?.id.company ||
                                      item?.item?.zoneSupplier?.name ||
                                      item.zoneSupplier?.id?.name ||
                                      item?.zoneSupplier?.id.company}
                                  </span>
                                  {item.status === "pending" && (
                                    <button
                                      onClick={() =>
                                        removeSupplier(item, requests)
                                      }
                                      className="w-5 h-5 flex items-center justify-center bg-red-500 text-white rounded-full hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-opacity-50"
                                    >
                                      <svg
                                        className="w-3 h-3"
                                        fill="none"
                                        stroke="white"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M6 18L18 6M6 6l12 12"
                                        ></path>
                                      </svg>
                                    </button>
                                  )}
                                </div>
                              </>
                            )
                          ) : (
                            <button
                              onClick={() => {
                                const focusState = `${requestIndex}-${itemIndex}`;
                                setFocusedItem(focusState);
                                navigate("assignSupplier", {
                                  state: {
                                    requests,
                                    request,
                                    item,
                                    focusedItem: focusState,
                                  },
                                });
                              }}
                              className="bg-fmb text-white py-2 px-3 rounded text-sm font-normal hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50"
                            >
                              Check Suppliers
                            </button>
                          )}
                        </div>
                      </div>
                      {itemIndex < request.items.length - 1 && (
                        <hr className="border-gray-300 my-2" />
                      )}
                    </React.Fragment>
                  ))}
                  <div className="flex justify-center">
                    {request.supplierSelected ||
                    newlyApprovedIndexes.includes(requestIndex) ? (
                      <button
                        ref={(el) => (submitRefs.current[request._id] = el)}
                        disabled={
                          (!request.supplierSelected &&
                            !newlyApprovedIndexes.includes(requestIndex)) ||
                          loadingRequests.includes(request._id)
                        }
                        onClick={(e) =>
                          submitSupplierForRequest(e, request, request.items)
                        }
                        className="bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-opacity-50"
                      >
                        {loadingRequests.includes(request._id)
                          ? "Submitting..."
                          : "Submit"}
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div
          className="fab-container"
          onClick={() => {
            setUser({ ...user, zone: requests });
            navigate("/zc/create-request");
          }}
        >
          <button className="fab-button bg-fmb">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
          </button>
          <span className="fab-text text-fmb">Create New Request</span>
        </div>
      </div>
    </>
  );
};

export default Requests;